import grzx from "./pages/index.vue";
import bjyx from "./pages/bjyx.vue";
import xgmm from "./pages/xgmm.vue";
import xgsj from "./pages/xgsj.vue";
import bjxg from './pages/bjxg.vue';

export default {
  path: "/bjxg",
  component: bjxg,
  children: [
  {
    path: "/bjxg/bjyx",
    component: bjyx,
  },
  {
    path: "/bjxg/xgmm",
    component: xgmm,
  },
  {
    path: "/bjxg/xgsj",
    component: xgsj,
  },
  {
    path: "/grzx",
    component: grzx,
  }
  
],
}



// WEBPACK FOOTER //
// ./src/views/grzx/router.js